import * as T from './actionTypes';

const INIT_STATE = {
  // Contractor cost lines for the currently-viewed WO
  lines: [],
  linesLoading: false,
  linesError: null,
  mutating: false,
  mutateError: null,
  mutateSuccess: null,

  // Aggregate WO cost (admin-only path)
  cost: null,
  costLoading: false,
  costError: null,
};

const upsert = (list, item) => {
  if (!item) return list;
  const idx = list.findIndex((x) => x.id === item.id);
  if (idx === -1) return [...list, item];
  const next = list.slice();
  next[idx] = item;
  return next;
};

const WorkOrderCost = (state = INIT_STATE, action) => {
  switch (action.type) {
    case T.FETCH_CONTRACTOR_COST:
      return { ...state, linesLoading: true, linesError: null };
    case T.FETCH_CONTRACTOR_COST_SUCCESS:
      return { ...state, linesLoading: false, lines: action.payload || [] };
    case T.FETCH_CONTRACTOR_COST_FAIL:
      return { ...state, linesLoading: false, linesError: action.payload };

    case T.CREATE_CONTRACTOR_COST:
    case T.UPDATE_CONTRACTOR_COST:
    case T.DELETE_CONTRACTOR_COST:
      return { ...state, mutating: true, mutateError: null, mutateSuccess: null };

    case T.CREATE_CONTRACTOR_COST_SUCCESS:
    case T.UPDATE_CONTRACTOR_COST_SUCCESS:
      return { ...state, mutating: false, mutateSuccess: 'OK', lines: upsert(state.lines, action.payload) };

    case T.DELETE_CONTRACTOR_COST_SUCCESS:
      return {
        ...state,
        mutating: false,
        mutateSuccess: 'OK',
        lines: state.lines.filter((x) => x.id !== action.payload),
      };

    case T.CREATE_CONTRACTOR_COST_FAIL:
    case T.UPDATE_CONTRACTOR_COST_FAIL:
    case T.DELETE_CONTRACTOR_COST_FAIL:
      return { ...state, mutating: false, mutateError: action.payload };

    case T.FETCH_WORK_ORDER_COST:
      return { ...state, costLoading: true, costError: null };
    case T.FETCH_WORK_ORDER_COST_SUCCESS:
      return { ...state, costLoading: false, cost: action.payload };
    case T.FETCH_WORK_ORDER_COST_FAIL:
      return { ...state, costLoading: false, costError: action.payload };

    case T.CLEAR_WORK_ORDER_COST_MESSAGES:
      return { ...state, mutateError: null, mutateSuccess: null, costError: null };

    default:
      return state;
  }
};

export default WorkOrderCost;
